import { createSelector } from "@reduxjs/toolkit";
import { replace } from "connected-react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDashboardFullPathInformations } from "./hooks/use-current-dashboard";
import { useGetEntityInfo } from "./hooks/use-get-dashboards-by-type";
import { InsWorkspaceActionBar } from "./insWorkspaceActionBar";
import { InsWorkspaceAnalysisPane } from "./insWorkspaceAnalysisPane";
import { moduleName } from "./store";
import { InsLeftPane } from "components/layout";
import { language } from "language/default";
import "../workspaces/left-pane/insDesignerLeftPane.scss";
const EMPTY_WORKSPACE = {};
export const useHandleSelectWorksapce = () => {
    const dispatch = useDispatch();
    const { pathInformations } = useDashboardFullPathInformations();
    const handleSelect = (option) => {
        dispatch(replace(`${pathInformations.slice(0, 3).join("/")}/${option.id}`));
    };
    return { handleSelect };
};
export const globalWorkspaceSelector = createSelector([
    (o) => o[moduleName]?.workspacesAndPreferences.find((e) => e.id === o[moduleName].currentWorkspace) ||
        o[moduleName]?.workspacesAndPreferences.find((e) => e.isDefault) || EMPTY_WORKSPACE,
    (o) => o[moduleName]?.analyses ?? [],
    (o) => o[moduleName]?.workspacesAndPreferences,
    (o) => o[moduleName]?.workspacesAndPreferencesChanges,
    (o) => o[moduleName]?.currentWorkspaceChanges
], (currentWorkspace, analyses, workspacesAndPreferences, workspacesAndPreferencesChanges, currentWorkspaceChanges) => ({ analyses, currentWorkspace, currentWorkspaceChanges, workspacesAndPreferences, workspacesAndPreferencesChanges }));
export const InsWorkspaceLeftPane = () => {
    const { currentWorkspace } = useSelector((state) => globalWorkspaceSelector(state));
    const entity = useGetEntityInfo();
    /*
     * Workspace preferences are now fetched in InsDashboardContainer
     * This ensures the data is available before this component renders
     */
    const workspacePreferencesQueryState = { isFinished: true, isPending: false };
    return React.createElement(InsLeftPane, { paneId: String(entity.type), assistiveLabel: "", header: language.en.workspace.workspaceLabel },
        React.createElement(InsWorkspaceActionBar, { workspacePreferencesQueryState: workspacePreferencesQueryState }),
        Object.keys(currentWorkspace).length > 0 &&
            React.createElement(InsWorkspaceAnalysisPane, null));
};
